/** iPhone-style bezel around an app screenshot. */
export const PhoneFrame = ({ src, alt, className = '' }: { src: string; alt: string; className?: string }) => (
  <div className={`rounded-[2.6rem] bg-black p-[9px] shadow-[0_30px_60px_-20px_rgba(20,47,114,0.45)] ${className}`}>
    <img src={src} alt={alt} className="block w-full rounded-[2.05rem]" loading="lazy" />
  </div>
);
